import windowActions from '../actions/windowActions';

const
{ RESIZE } = windowActions,
init = {
    height: window.innerHeight,
    width: window.innerWidth,
    minWidth: '720px',
    minHeight: '480px',
    displayType: 'desktop'
};

export default (state=init, action) => {
    switch(action.type) {
        case RESIZE:
            const { h, w, d } = action.payload;
            return {...state, height: h, width: w, displayType: d };
        default:
            return {...state};
    }
}
